import React, { Component } from 'react'
import './contact.scss'

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {name: '', phone: '', email: '', subject: '', message: ''};
        this.submitContact = this.submitContact.bind(this);
    }

    handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    submitContact= () => {
        event.preventDefault();

        if (this.state.email === '' && this.state.phone === '') {
            alert('You must enter at least one piece of contact information');
            return;
        }

        if (!this.state.message) {
            alert('You must enter a message.');
            return;
        }

        var data = {
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email,
            subject: this.state.subject,
            message: this.state.message
        };

        document.getElementById('message-container').classList.remove('hide');
        document.getElementById("contact-form").style.display = "none";

        console.log("Sending email...")
        fetch('https://7a30o1ool7.execute-api.eu-west-1.amazonaws.com/prod/contact-us', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          crossDomain: "true",
          body: JSON.stringify(data)
        })
        .then(
            (result) => {
                document.getElementById('contact-loader').classList.add('hide');
                document.getElementById("contact-success").style.display = "block";
            }
        );
    }

      render() {
          let instagram = 'http://www.instagram.com/' + this.props.instagram;
          let facebook = 'https://www.facebook.com/' + this.props.facebook;

          return (
              <section id="contact">
                  <div className="img"></div>
                  <div className="container">
                      <h5>Contact Us</h5>
                      <div className="row justify-content-center row-eq-height mb-4">
                          <div className="col-md-4 text-center my-auto right-vert-separator">
                              <div className="contact-box">
                                  <div className="contact-inner pt-4 pb-4">
                                  <div className="icon mb-3">
                                      <i className="fas fa-map-marker-alt"></i>
                                  </div>
                                  <h6 className="mb-3">Address</h6>
                                  <div className="detail">Pontardawe,<br></br>
                                      Swansea
                                  </div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-4 text-center my-auto right-vert-separator">
                              <div className="contact-box">
                                  <div className="contact-inner pt-4 pb-4">
                                      <div className="icon mb-3">
                                          <i className="fas fa-mobile-alt"></i>
                                      </div>
                                      <h6 className="mb-3">Phone</h6>
                                      <div className="detail">+44 (0) 78944 30987</div><br className="d-none d-md-block"></br>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-4 text-center my-auto">
                              <div className="contact-box">
                                  <div className="contact-inner pt-4 pb-4">
                                      <div className="icon mb-3">
                                          <i className="far fa-envelope"></i>
                                      </div>
                                      <h6 className="mb-3">Email</h6>
                                      <div className="detail"><a href="mailto:info@ercsolutions.co.uk">info@ercsolutions.co.uk</a></div><br className="d-none d-md-block"></br>
                                  </div>
                              </div>
                          </div>

                      </div>
                      <div className="row">
                          <div className="col-lg-6 mx-auto">
                              <h5 id="message-title">Send us a message</h5>
                              <div className="text-center mb-4">If you have any questions, just drop us a message!</div>
                              <form id="contact-form" onSubmit={this.submitContact}>
                                  <div className="form-row form-group">
                                      <div className="col">
                                          <input type="text" className="form-control" id="name" placeholder="Your name" value={this.state.name} onChange={this.handleChange}/>
                                      </div>
                                      <div className="col">
                                          <input type="email" className="form-control" id="email" name="email" placeholder="Email address" value={this.state.email} onChange={this.handleChange}/>
                                      </div>
                                  </div>
                                  <div className="form-row form-group">
                                      <div className="col">
                                          <input type="tel" className="form-control" id="phone" placeholder="Phone no" value={this.state.phone} onChange={this.handleChange}/>
                                      </div>
                                      <div className="col">
                                          <input type="text" className="form-control" id="subject" name="subject" placeholder="Subject" value={this.state.subject} onChange={this.handleChange}/>
                                      </div>
                                  </div>
                                  <div className="form-row form-group">
                                      <div className="col">
                                          <textarea type="text" className="form-control" id="message" name="message" placeholder="Message" value={this.state.message} onChange={this.handleChange}></textarea>
                                      </div>
                                  </div>
                                  <div className="form-row form-group">
                                     <div className="col text-center">
                                         <button type="submit">Send Message</button>
                                      </div>
                                  </div>
                              </form>
                              <div id="message-container" className="justify-content-center my-5 hide">
                                  <div id="contact-loader">
                                      <div className="loader"></div>
                                      <div className="loader-text">Sending message...</div>
                                  </div>
                                  <div id="contact-success">
                                      Thanks for contacting us!  A member of our team will be in touch with you shortly.
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="connect mt-5 mb-3 text-center">Connect with us!</div>
                      <div className="row justify-content-center">
                          <div className="col-lg-8 text-center">
                              <div className="contact-text">
                              </div>
                              <div className="social-links">
                                  <a className="mr-4" href={facebook}>
                                      <i className="fab fa-facebook-f"></i>
                                  </a>
                                  <a className="mr-4" href={instagram}>
                                      <i className="fab fa-instagram"></i>
                                  </a>
                                  <a href="https://www.linkedin.com/company/14822209">
                                      <i className="fab fa-linkedin-in"></i>
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
          );
      }
 }

 export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js